<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          :src="smallLogoSrc"
          :width="smallLogoWidth"    
          alt=""
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/sygnet.svg"
          width="30"
          height="30"
          alt=""
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="true"
          loader="dots"
          background-color="#ffffff"
          color="#E75A1C"
        ></loading>
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="#">{{partnerName}}</a>
        <span class="ml-1">&copy; 2022.</span>
      </div>
      <div class="ml-auto">
        <a href="#">Versão</a>
        v{{$store.getters.appVersion}}
      </div>
    </TheFooter>
    <b-modal
      id="modal-change-password"
      ref="changePasswordModal"
      title="Alterar Senha"
      @hidden="resetChangePasswordModel"
      @ok="handleChangePasswordOk"
      ok-title="Alterar"
      cancel-title="Cancelar"
      v-model="showResetPasswordModal"
    >
      <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
      <form ref="form" @submit.stop.prevent="handleSubmit" class="needs-validation" novalidate>
        <div class="form-row">
          <div class="col-sm-6">
            <base-input
              required
              label="Senha"
              maxlength="20"
              v-model="model.password"
              type="password"
              v-validate="modelValidations.password"
              placeholder="Senha"
              :error="getError('password')"
              data-vv-name="password"
              data-vv-as="senha"
            />
          </div>
          <div class="col-sm-6">
            <base-input
              required
              label="Digite a nova senha"
              maxlength="20"
              v-model="model.newPassword"
              type="password"
              v-validate="modelValidations.newPassword"
              placeholder="Digite a nova senha"
              :error="getError('newPassword')"
              data-vv-name="newPassword"
              data-vv-as="nova senha"
            />
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import nav from "@/_nav";
import config from '../config';
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Vue from "vue";
import eventbus from "../eventBus";
import identityService from "../services/Identity/identityService";

export default {
  name: "DefaultContainer",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: config.partnersConfiguration.apptitle,
    // all titles will be injected into this template
    //titleTemplate: '%s | My Awesome Webapp'
  },
  components: {
    AppHeader,
    AppSidebar,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    Loading
  },
  data() {
    return {
      isLoading: false,
      model: {
        password: "",
        newPassword: ""
      },
      modelValidations: {
        password: {
          required: true
        },
        newPassword: {
          required: true
        }
      },
      showResetPasswordModal: false,
      hasError: false,
      errorMessage: ""
    };
  },
  computed: {
    nav() {
      return nav.menu;
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.title
      );
    },
    smallLogoSrc() {
      return `${process.env.VUE_APP_STORAGE_URI}logo-small.png`
    },
    smallLogoWidth() {
      return config.partnersConfiguration.images.header.width
    },
    partnerName() {
      return config.partnersConfiguration.name
    }
  },
  mounted() {
    const self = this;
    eventbus.$on("ui-action:loading", function(show) {
      self.isLoading = show;
    });

    eventbus.$on("ui-action:change-password", function(show) {
      self.showResetPasswordModal = show;
    });
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    resetChangePasswordModel() {
      this.model.password = "";
      this.model.newPassword = "";
    },
    handleChangePasswordOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      const self = this;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          identityService.changePassword(this.model).then(
            response => {
              // Hide the modal manually
              self.$nextTick(() => {
                self.$refs.changePasswordModal.hide();
              });
            },
            error => {
              self.errorMessage = "Ocorreu um erro ao atualizar a senha.";
              self.hasError = true;
            }
          );
        }
      });
    }
  }
};
</script>
<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "../assets/scss/style";

#modal-payment-warning .modal-body {
  padding: 0 !important;
}

#modal-payment-warning .modal-content {
  width: 650px !important;
}
</style>